// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__evhVE","error":"FormInput_error__8Xebi"};